import * as yup from 'yup';

import '@utils/yup/string';
import { FormParam } from '@repositories/new-application';

export const defaultValues: FormParam<'family_information'> = {
  closeKinMobilePhone: '',
  closeKinName: '',
  kinMobilePhone: '',
  kinName: '',
  kinRelationship: '',
};

const schemes: Record<keyof FormParam<'family_information'>, unknown> = {
  closeKinMobilePhone: yup
    .string()
    .required('Kolom wajib diisi')
    .checkPhoneNumber('Nomor telepon tidak valid'),
  closeKinName: yup
    .string()
    .required('Kolom wajib diisi')
    .test(function (value) {
      return value.length > 100
        ? this.createError({
            path: this.path,
            message: 'Maksimal 100 karakter',
          })
        : true;
    }),
  kinMobilePhone: yup
    .string()
    .required('Kolom wajib diisi')
    .checkPhoneNumber('Nomor telepon tidak valid'),
  kinName: yup
    .string()
    .required('Kolom wajib diisi')
    .test(function (value) {
      return value.length > 100
        ? this.createError({
            path: this.path,
            message: 'Maksimal 100 karakter',
          })
        : true;
    }),
  kinRelationship: yup.string().required('Kolom wajib diisi'),
};

export const familyInformationSchema =
  yup.object<FormParam<'family_information'>>(schemes);
